import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Facebook, MessageCircle, Mail, ArrowUp, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  const footerLinks = {
    empresa: [
      { name: 'Nosotros', href: '/nosotros' },
      { name: 'Servicios', href: '/servicios' },
      { name: 'Destinos', href: '/destinos' },
      { name: 'Beneficios', href: '/beneficios' },
    ],
    soporte: [
      { name: 'Contacto', href: '/contacto' },
      { name: 'Términos', href: '#' },
      { name: 'Privacidad', href: '#' },
    ],
  };

  const socialLinks = [
    { name: 'Instagram', icon: Instagram, href: 'https://instagram.com/collegetraveler', color: 'hover:bg-pink-600' },
    { name: 'Facebook', icon: Facebook, href: 'https://facebook.com/collegetraveler', color: 'hover:bg-blue-600' },
    { name: 'LinkedIn', icon: Linkedin, href: 'https://linkedin.com/company/collegetraveler', color: 'hover:bg-blue-700' },
    { name: 'WhatsApp', icon: MessageCircle, href: 'https://wa.me/522282728556', color: 'hover:bg-green-600' },
  ];

  return (
    <footer data-testid="footer" className="bg-[#050505] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-12">
          {/* Brand Column - Original Logo */}
          <div className="col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <span className="text-xl font-extrabold tracking-tighter text-white">COLLEGE</span>
              <span className="text-xl font-light tracking-tight text-white/60">TRAVELER</span>
              <span className="w-2 h-2 rounded-full bg-[#009DE0]"></span>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-xs">
              Agencia de viajes de turismo académico a nivel nacional e internacional. 
              Diseñamos experiencias de primer nivel.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-3">
              {socialLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${social.name.toLowerCase()}`}
                    className={`w-10 h-10 bg-white/10 rounded-full flex items-center justify-center transition-colors ${social.color}`}
                  >
                    <IconComponent size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Empresa Links */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-6 text-white">Empresa</h4>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-white/50 hover:text-[#009DE0] transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Soporte Links */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-6 text-white">Soporte</h4>
            <ul className="space-y-3">
              {footerLinks.soporte.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-white/50 hover:text-[#009DE0] transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-6 text-white">Contacto</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2 text-white/50">
                <Mail size={14} />
                <span>info@collegetraveler.com</span>
              </div>
              <div className="flex items-center gap-2 text-white/50">
                <Phone size={14} />
                <span>+52 (228) 272 8556</span>
              </div>
              <div className="flex items-center gap-2 text-white/50">
                <MapPin size={14} />
                <span>Veracruz, México</span>
              </div>
              <a
                href="https://wa.me/522282728556"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-green-700 transition-colors mt-2"
              >
                <MessageCircle size={14} />
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} College Traveler. Todos los derechos reservados.
          </p>
          <button
            data-testid="back-to-top"
            onClick={scrollToTop}
            className="flex items-center gap-2 text-white/50 hover:text-[#009DE0] transition-colors text-sm"
          >
            <span>Volver arriba</span>
            <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
